import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IAttachment } from 'app/request-form/_models/attachment.interface';
import { MessageListViewModel } from 'app/request-form/_models/message-list.view-model';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageListComponent implements OnInit {
  @Input() viewModel: MessageListViewModel;

  @Output() clickItem = new EventEmitter<IAttachment>();

  showAllMessages = false;
  quantityItems: number;

  ngOnInit(): void {
    if (this.viewModel) {
      this.quantityItems = this.viewModel.quantityStartingItems;
    }
  }

  /**
   * Method called when attachment is clicked to download
   * @param attachment attachment clicked from attachment list
   */
  clickAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }

  /**
   * Change the variable that defines whether to show all messages
   */
  toggleShowAllMessages(): void {
    this.showAllMessages = !this.showAllMessages;
    this.setQuantityItems();
  }

  /**
   * Change the value of the variable that defines how many messages will be displayed
   */
  private setQuantityItems(): void {
    if (this.showAllMessages) {
      this.quantityItems = this.viewModel.messages.length;
    } else {
      this.quantityItems = this.viewModel.quantityStartingItems;
    }
  }
}
